// STE-29 (Markus 22.10.2026): Laufschrift der Message bar auf dem Handy.
// Mobil stehen Sale-Text, „Endet in“ und Countdown in EINER Zeile (Container .message-bar__track,
// sections/announcement-bar-os.liquid). Passt sie nicht, läuft sie hin und her statt im Kreis:
// Anfang zeigen, zum Ende fahren, kurz halten, zurück. Dieses Skript misst nur die Überlänge und
// setzt Strecke und Dauer; Bewegung und Layout stehen in assets/custom.css (sd-message-marquee).
// Auf dem Desktop (ab 1000 px) passiert nichts.
;(() => {
	const SPEED = 35 // Pixel pro Sekunde
	const mobile = window.matchMedia("(max-width: 999px)")

	function setup(bar) {
		if (bar.dataset.marqueeReady) return
		bar.dataset.marqueeReady = "true"
		const sales = [...bar.querySelectorAll(".message-bar__sale")].filter((sale) =>
			sale.querySelector(".message-bar__track"),
		)
		if (!sales.length) return

		let timer = null
		const measure = () => {
			timer = null
			sales.forEach((sale) => {
				const track = sale.querySelector(".message-bar__track")
				const overflow = mobile.matches && !sale.hidden ? Math.ceil(track.scrollWidth - sale.clientWidth) : 0
				const previous = Number(sale.dataset.marqueeOverflow || 0)
				// Der Countdown ändert sich jede Sekunde; nur bei spürbarer Änderung neu setzen (sonst springt die Bewegung).
				if (Math.abs(overflow - previous) < 4 && overflow > 0 === previous > 0) return
				sale.dataset.marqueeOverflow = String(overflow)
				sale.classList.toggle("is-scrolling", overflow > 0)
				if (overflow > 0) {
					// 70 % der Zeit Fahrt, je 15 % Halt am Anfang und Ende (Keyframes sd-message-marquee).
					const duration = Math.max(3, overflow / SPEED / 0.7)
					sale.style.setProperty("--marquee-distance", `-${overflow}px`)
					sale.style.setProperty("--marquee-duration", `${duration.toFixed(1)}s`)
				}
			})
		}
		// Kurzer Timer statt requestAnimationFrame: läuft auch, wenn der Browser keine Frames zeichnet
		// (z. B. Tab im Hintergrund, eingebettete Vorschau), und bündelt die Messungen.
		const schedule = () => {
			if (!timer) timer = window.setTimeout(measure, 50)
		}
		if ("ResizeObserver" in window) new ResizeObserver(schedule).observe(bar)
		else window.addEventListener("resize", schedule)
		// Weglot tauscht die Texte nach dem Laden aus; ein anderer Sale kann starten (hidden wechselt).
		new MutationObserver(schedule).observe(bar, {
			childList: true,
			characterData: true,
			subtree: true,
			attributes: true,
			attributeFilter: ["hidden"],
		})
		mobile.addEventListener?.("change", schedule)
		document.fonts?.ready?.then(schedule)
		measure()
	}

	const init = () => document.querySelectorAll("message-bar").forEach(setup)
	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init)
	else init()
})()
